import script from "./LeitnerReview.vue?vue&type=script&setup=true&lang=ts"
export * from "./LeitnerReview.vue?vue&type=script&setup=true&lang=ts"

import "./LeitnerReview.vue?vue&type=style&index=0&id=42278ac9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-42278ac9"]])

export default __exports__